import Section from './Section'
import SectionTitle from './SectionTitle'
import SectionDescription from './SectionDescription'

Section.Title = SectionTitle
Section.Description = SectionDescription

export default Section
